import Layout from "../../Containers/Layout";
import DocumentsTable from "./DocumentsTable";

const Documents = () => {
	return (
		<Layout>
			<div className="px-4 pb-10 flex flex-col">
				<DocumentsTable />
			</div>
		</Layout>
	);
};
export default Documents;
